<template>
  <div v-if="type === 'xs'">
    <div class="flex flex-col h-[100dvh] landscape:h-screen bg-gray-50">
      <div
        class="flex flex-col space-y-2 pb-4 pt-6 pl-4 text-xl font-medium text-gray-900 bg-white border-b"
      >
        <h1 class="font-semibold">
          {{ t("admin.settings.personal.title") }}
        </h1>
      </div>

      <div
        class="flex flex-col divide-gray-200 divide-y bg-white border-b border-b-gray-200"
      >
        <Link
          v-for="item in settings"
          :key="item.name"
          :href="item.href"
          class="flex items-center px-6 py-5 text-sm font-medium text-gray-900"
        >
          <component
            :is="item.icon"
            class="mr-3 flex-shrink-0 h-5 w-5 text-gray-900"
            aria-hidden="true"
          />
          <span class="truncate flex-1">{{ item.name }}</span>
          <ChevronRight class="w-10 text-gray-400 -mr-3" />
        </Link>
        <div
          class="flex items-center px-6 py-5 text-sm font-medium text-gray-900"
          @click="handleLogout"
        >
          <ArrowLeftOnRectangleIcon
            class="mr-3 flex-shrink-0 h-5 w-5 text-gray-900"
            aria-hidden="true"
          />
          <span>{{ t("components.buttons.logout") }}</span>
        </div>
      </div>
    </div>
    <MobileNavigation class="py-1" />
    <trial-countdown />
  </div>
</template>

<script setup>
import UserCircle from "@/Tailwind/Icon/UserCircle.vue";
import route from "ziggy-js";
import SettingsOne from "@/Tailwind/Icon/SettingsOne.vue";
import { Link, usePage } from "@inertiajs/vue3";
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";
import { onBeforeMount, unref, ref } from "vue";
import { router } from "@inertiajs/vue3";
import ChevronRight from "@/Tailwind/Icon/ChevronRight.vue";
import MobileNavigation from "@/Tailwind/Components/MobileNavigation.vue";
import { ArrowLeftOnRectangleIcon } from "@heroicons/vue/20/solid";

import { useI18n } from "vue-i18n";
import { useWebView } from "@/Tailwind/Mixins/useWebView";
import { useDevice } from "@/Tailwind/Mixins/useDevice";
import TrialCountdown from "@/Tailwind/Components/TrialCountdown.vue";
import { useCookies } from "vue3-cookies";
import { useFilterStore } from "@/Tailwind/Stores/filters";
import { usePreloadStore } from "@/Tailwind/Stores/preload";
const { t } = useI18n();

const tenant = usePage().props.tenant;

const { type } = useBreakpoints();
const { cookies } = useCookies();

// @todo Not ideal, but works for now. Ensures this page is only usable on Mobile.
onBeforeMount(() => {
  if (unref(type) !== "xs") {
    router.visit(route("settings.user.profile", [tenant]));
  }
});

const filterStore = useFilterStore();
const { runningInWebView } = useWebView();
const { logoutDevice } = useDevice();

const preloadStore = usePreloadStore();

function handleLogout() {
  if (runningInWebView()) {
    logoutDevice();
  }

  cookies.remove("hide_trial_info");
  router.post(
    route("logout"),
    {},
    {
      onSuccess: () => {
        filterStore.clearFilters();
        preloadStore.clear();
      },
    }
  );
}

const settings = ref([
  {
    name: t("admin.settings.personal.profile.title"),
    icon: UserCircle,
    href: route("settings.user.profile.index"),
    current: true,
  },
  {
    name: t("admin.settings.personal.account.title"),
    icon: SettingsOne,
    href: route("settings.user.account.index"),
    current: false,
  },
]);
</script>
